import { find } from 'lodash';
import {
  POLL_LIST_REQUEST,
  POLL_LIST_REQUEST_ERROR,
  POLL_LIST_REQUEST_SUCCESS,
  POLL_CREATE,
  POLL_CREATE_SUCCESS,
  POLL_CREATE_ERROR,
  POLL_UPDATE,
  POLL_UPDATE_SUCCESS,
  POLL_UPDATE_ERROR,
  POLL_DELETE,
  POLL_DELETE_SUCCESS,
  POLL_DELETE_ERROR,
} from '@/store/actions/poll';
import { handleRequestError } from '@/utils/error';
import Repository, { POLLS } from '@/repositories/RepositoryFactory';

const PollsRepository = Repository.get(POLLS);

const state = {
  status: '',
  poll: {},
  pollList: [],
  pollListMeta: {},
  pollListStatus: '',
};

const getters = {
  pollStatus: state => state.status,
  pollList: state => state.pollList,
  pollListMeta: state => state.pollListMeta,
  pollListStatus: state => state.pollListStatus,
  getPollById: (state, getters) => id => {
    if (getters.pollList.length > 0) {
      return find(getters.pollList, { id });
    }
    return state.poll;
  },
};

const actions = {
  [POLL_LIST_REQUEST]: async ({ commit }, payload) => {
    commit(POLL_LIST_REQUEST);
    try {
      const response = await PollsRepository.get(payload);
      commit(POLL_LIST_REQUEST_SUCCESS, response.data);
    } catch (error) {
      commit(POLL_LIST_REQUEST_ERROR);
      handleRequestError(error);
    }
  },
  [POLL_CREATE]: async ({ commit }, payload) => {
    commit(POLL_CREATE);
    try {
      await PollsRepository.create(payload);
      commit(POLL_CREATE_SUCCESS);
    } catch (error) {
      commit(POLL_CREATE_ERROR);
      handleRequestError(error);
    }
  },
  [POLL_UPDATE]: async ({ commit }, { id, data }) => {
    commit(POLL_UPDATE);
    try {
      await PollsRepository.update(id, data);
      commit(POLL_UPDATE_SUCCESS);
    } catch (error) {
      commit(POLL_UPDATE_ERROR);
      handleRequestError(error);
    }
  },
  [POLL_DELETE]: async ({ commit }, id) => {
    commit(POLL_DELETE);
    try {
      await PollsRepository.delete(id);
      commit(POLL_DELETE_SUCCESS);
    } catch (error) {
      commit(POLL_DELETE_ERROR);
      handleRequestError(error);
    }
  },
};

/* eslint-disable no-param-reassign */
const mutations = {
  [POLL_LIST_REQUEST]: state => {
    state.pollListStatus = 'loading';
  },
  [POLL_LIST_REQUEST_SUCCESS]: (state, payload) => {
    state.pollListStatus = 'success';
    state.pollList = payload.data;
    if (payload.meta) {
      state.pollListMeta = payload.meta;
    }
  },
  [POLL_LIST_REQUEST_ERROR]: state => {
    state.pollListStatus = 'error';
  },
  [POLL_CREATE]: state => {
    state.status = 'loading';
  },
  [POLL_CREATE_SUCCESS]: state => {
    state.status = 'success';
  },
  [POLL_CREATE_ERROR]: state => {
    state.status = 'error';
  },
  [POLL_UPDATE]: state => {
    state.status = 'loading';
  },
  [POLL_UPDATE_SUCCESS]: state => {
    state.status = 'success';
  },
  [POLL_UPDATE_ERROR]: state => {
    state.status = 'error';
  },
  [POLL_DELETE]: state => {
    state.status = 'deleting';
  },
  [POLL_DELETE_SUCCESS]: state => {
    state.status = 'deleted';
  },
  [POLL_DELETE_ERROR]: state => {
    state.status = 'error';
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
